/**
 * @description Функция для разделения фразы на две строки
 */
export function splitPhraseIntoTwoLines(phrase) {
  var words = phrase.split(' '); // Разделяем фразу на слова

  var totalLength = phrase.length;
  var currentLength = 0;
  var splitIndex = 0;
  while (splitIndex < words.length) {
    var word = words[splitIndex];
    if (currentLength + word.length + 1 <= totalLength / 2) {
      currentLength += word.length + 1; // Учитываем пробел

      splitIndex++;
    } else {
      break;
    }
  }
  return [words.slice(0, splitIndex).join(' '), words.slice(splitIndex).join(' ')];
}